import { createModalState } from '../utils/create-modal-state';

export const useDemoRequestModal = createModalState();
